import { atom } from 'recoil';

const $userCompanyIndex = atom<number>({
    key: 'user-company-index',
    default: 0,
});

export default $userCompanyIndex;
